import { render } from "./Epic.vue?vue&type=template&id=1f9c13d4"
import script from "./Epic.vue?vue&type=script&lang=js"
export * from "./Epic.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__